import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getEmployeeDictionary } from '@/pages/baseData/employee/api'
import { getLocalStorage, setLocalStorage } from '@/utils/tools'

const employeeDictionaryCacheKey = 'cache-employee-dictionary'
const employeeDictionaryCache = getLocalStorage(employeeDictionaryCacheKey)
export const fetchGetEmployeeDictionaryAsync = createAsyncThunk(
  'hrm/getEmployeeDictionary',
  () =>
    axios
      .get(getEmployeeDictionary(employeeDictionaryCache?.version ?? ''))
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        if (
          resp.data === null &&
          resp.version === employeeDictionaryCache?.version
        ) {
          return employeeDictionaryCache.data ?? []
        } else {
          setLocalStorage(employeeDictionaryCacheKey, resp)
          return resp.data ?? []
        }
      })
      .catch((err) => {
        throw Error('读取员工数据缓存失败')
      })
)
const hrmSlice = createSlice({
  name: 'hrm',
  initialState: {
    empDict: {},
    empList: [],
  },
  reducers: {
    setEmpDict(state, action) {
      state.empDict = action.payload
    },
    setEmpList(state, action) {
      state.empList = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetEmployeeDictionaryAsync.pending, (state) => {
        state.empDict = {}
        state.empList = []
      })
      .addCase(fetchGetEmployeeDictionaryAsync.fulfilled, (state, action) => {
        state.empDict = action.payload
        for (const key in action.payload) {
          const item = action.payload[key]
          state.empList.push(item)
        }
      })
  },
})

export const { setEmpDict } = hrmSlice.actions
export const getEmpDict = (state) => state.hrm.empDict
export const getEmpList = (state) => state.hrm.empList
export default hrmSlice.reducer
